/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
import { useEffect, useState, useRef } from 'react';
import { Tabs, Tab, Container, Row, Col } from 'react-bootstrap';
import CustomSelect2 from '../../customSelect2/CustomSelect2';
import { RadioButton } from '../../button';
import selectArrow from '../../../assets/images/svg/arrow-down-black.svg';
import DoctorListingBox from '../../doctorListingBox/DoctorListingBox';
import image from '../../../assets/images/png/article2.png';
import platinium from '../../../assets/images/svg/platinium-rank.svg';
import silver from '../../../assets/images/svg/silver-rank.svg';
import { SheduleAppointment } from '../../customModals';
import './findDoctorFilter.css';

const filterBtns = [
  { text: 'Available Now', id: '1', htmlFor: '1' },
  { text: 'Available Today', id: '2', htmlFor: '2' },
  { text: 'Sort by Fees', id: '3', htmlFor: '3' },
  { text: 'Most Reviewed', id: '4', htmlFor: '4' },
  { text: 'Most Experience', id: '5', htmlFor: '5' }
];

const timeOfDay = [
  { label: '10:30 am', value: '10:30 am' },
  { label: '11:30 am', value: '11:30 am' },
  { label: '12:30 pm', value: '12:30 pm' }
];

const gender = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' }
];

const doctorListingData = [
  {
    docImg: image,
    docImgBgColor: '#ef6286',
    docName: 'Dr. Madeeha Asad',
    speciality: 'Gynecologist, Obstetrician',
    education: 'M.B.B.S, F.C.P.S (Gynecology & Obstetrics), MRCOG',
    rating: '4.92',
    people: '24',
    rank: platinium,
    rankColor: '#FFEDC9',
    rankText: 'platinuim',
    years: '20',
    waitTime: '15',
    online: true,
    locations: [
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'START VIDEO CONSULTATION'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      }
    ]
  },
  {
    docImg: image,
    docImgBgColor: '#f5d730',
    docName: 'Dr. Madeeha Asad',
    speciality: 'Gynecologist, Obstetrician',
    education: 'M.B.B.S, F.C.P.S (Gynecology & Obstetrics), MRCOG',
    rating: '4.92',
    people: '24',
    rankColor: '#E6E6E6',
    rank: silver,
    rankText: 'silver',
    years: '20',
    waitTime: '15',
    online: true,
    locations: [
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'START VIDEO CONSULTATION'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      }
    ]
  },
  {
    docImg: image,
    docImgBgColor: '#ef6286',
    docName: 'Dr. Madeeha Asad',
    speciality: 'Gynecologist, Obstetrician',
    education: 'M.B.B.S, F.C.P.S (Gynecology & Obstetrics), MRCOG',
    rating: '4.92',
    people: '24',
    rankColor: '',
    rank: '',
    rankText: '',
    years: '20',
    waitTime: '15',
    online: '',
    locations: [
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      }
    ]
  },
  {
    docImg: image,
    docImgBgColor: '#72d54a',
    docName: 'Dr. Madeeha Asad',
    speciality: 'Gynecologist, Obstetrician',
    education: 'M.B.B.S, F.C.P.S (Gynecology & Obstetrics), MRCOG',
    rating: '4.92',
    people: '24',
    rankColor: '',
    rank: '',
    rankText: '',
    years: '20',
    waitTime: '15',
    online: '',
    locations: [
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      }
    ]
  }
];

function FindDoctorFilter() {
  const [modal, setModal] = useState('false');
  const [keyForTabs, setKeyForTabs] = useState('');

  const [dictionary, setDictionary] = useState(new Map());

  // sort all diseases based on first letter
  // link diseases with letters
  useEffect(() => {
    setDictionary(dictionary);
    setKeyForTabs('allAppointments');
  }, []);

  const ForTop = useRef(null);

  return (
    <section className="findDoctorFilter" ref={ForTop}>
      <Container>
        <div className="tabContainer">
          <Tabs
            id="controlled-tab-speciality"
            activeKey={keyForTabs}
            transition
            onSelect={(k) => setKeyForTabs(k)}
            className="mb-3 customTabs"
          >
            <Tab eventKey="allAppointments" title="All appointments">
              <div className="filter_btns">
                {filterBtns.map((filterBtn) => {
                  const { text, id, htmlFor } = filterBtn;
                  return <RadioButton text={text} id={id} htmlFor={htmlFor} />;
                })}
                <CustomSelect2
                  options={timeOfDay}
                  placeholder="Time of Day"
                  icon={selectArrow}
                />
                <CustomSelect2
                  options={gender}
                  placeholder="Gender"
                  icon={selectArrow}
                />
              </div>
              <Row>
                <Col md={12}>
                  {doctorListingData.map((doctorListing, index) => {
                    const {
                      docImg,
                      docImgBgColor,
                      docName,
                      speciality,
                      education,
                      rating,
                      people,
                      rank,
                      rankColor,
                      rankText,
                      years,
                      waitTime,
                      online,
                      price,
                      locations
                    } = doctorListing;
                    return (
                      <div key={index}>
                        <DoctorListingBox
                          docImg={docImg}
                          docImgBgColor={docImgBgColor}
                          docName={docName}
                          speciality={speciality}
                          education={education}
                          rating={rating}
                          people={people}
                          rank={rank}
                          color={rankColor}
                          rankText={rankText}
                          years={years}
                          waitTime={waitTime}
                          online={online}
                          price={price}
                          locations={locations}
                        />
                      </div>
                    );
                  })}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="inPerson" title="In-person" />
            <Tab eventKey="videoConsultation" title="Video Consultation" />
            <Tab eventKey="city" title="By City" />
          </Tabs>
        </div>
        <SheduleAppointment
          show={modal === 'm1'}
          close={() => setModal(false)}
          onClick={() => setModal('m2')}
        />
      </Container>
    </section>
  );
}

export default FindDoctorFilter;
